module.exports = __webpack_public_path__ + "static/app-store-badge-en-4b20d647f5a05fc1d3c17cbefea9beb1.png";